export const HiddenErrorName = "HiddenError";
export class ErrorHiddenFromConsole extends Error {
  name = HiddenErrorName;
}

export const isHiddenError = (error: Error): boolean => {
  return error.name == HiddenErrorName;
};
